module.exports = __webpack_public_path__ + "static/media/gwen-stacy.202e21e5.png";